import {PublicRoutes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';

export const isPublicPage = (url: string) => {
  return PublicRoutes.some((publicRoute) => routingService.isMatchRoute(publicRoute, url));
};
